import React from 'react';

const ErrorMessage = ({className = "", ...props}) => {
    return (
        <div className={`font-bold text-red-600 ${className}`}>
            {props.children}
        </div>
    );
};

export default ErrorMessage;